var render = function render(_c,_vm){return _c('span',{class:{
    [`font--${_vm.props.fontStyle}-${_vm.props.fontSize}`]:
      !!_vm.props?.fontStyle && !!_vm.props?.fontSize,
    [`g-text-${_vm.props?.color}`]: !!_vm.props?.color,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }